import { render } from "./ContattoCard.vue?vue&type=template&id=bd01dc8c&ts=true"
import script from "./ContattoCard.vue?vue&type=script&lang=ts"
export * from "./ContattoCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__